export default __webpack_public_path__ + "static/media/imgunidades.d7c95848.png";